export const isDisabled = (values, isValid) => {
    let disabled = false;

    if (isValid) {
        for (const key in values) {
            if (values[key].length <= 0) {
                disabled = true;
            }
        }
        return disabled;
    }
    disabled = true;
    return disabled;
};
